import React, { useContext, useEffect, useState } from 'react';
import { AccountClient } from '@nile/graphql';
import { GET_REPORT } from '@nile/reports/src/modules/reports/graphql';
import Loading from '@nile/components/src/Svg/AnimatedSvg/Loading.svg';
import { RETAINER } from '@nile/reports/src/modules/home/constants';
import { EventEmitter } from '@nile/components';
import ReportsContext from '@nile/reports/src/modules/home/contexts/Reports';

import RetainerReportSheet from './RetainerReportSheet';

interface RetainerReportProps {
  data: {
    reportId: string;
    internalName: string;
    reportType: string;
  };
  setActiveReport: (report: { reportId: string; internalName: string }) => void;
  setActiveReportLoading: (loading: boolean) => void;
}

interface ReportData {
  reportId?: string;
  name?: string;
  description?: string;
  createdBy?: {
    userId: string;
    name: string;
    email: string;
  };
  fullScreenModeEnabled?: boolean;
  fullScreenModeRefreshInterval?: number;
  internalName?: string;
  reportConfig?: {
    metric: string;
    enabled: boolean;
    condition: {
      value: {
        data: string;
        unit: string;
      };
      operator: string;
      attribute: string;
    };
  }[];
  createdTime?: string;
  selectAttributes?: string[];
  reportType?: 'METRIC' | 'PDF' | 'DATA';
  systemReport?: boolean;
  entity?: string;
  layout?: {
    layout?: {
      h: number;
      i: string;
      w: number;
      x: number;
      y: number;
      minH: number;
      minW: number;
      advancedChart?: {
        api: string;
        dataKey: string;
        cellType: 'CURRENCY' | 'CURRENCY_HOUR';
        labelKey: string;
        listInfo: boolean;
        defaultChartType:
          | 'NUMBERCARD'
          | 'SUPERTABLE'
          | 'CUSTOMCHART'
          | 'SUPERCHART'
          | 'SUPERMETACHART';
      };
      advancedMetaChart?: {
        api: string;
        dataKey: string;
        cellType: 'CURRENCY' | 'CURRENCY_HOUR';
        labelKey: string;
        listInfo: boolean;
        defaultChartType: 'NUMBERCARD';
      };
    }[];
  };
}

function RetainerReport(props: RetainerReportProps) {
  const { data, setActiveReport, setActiveReportLoading } = props;

  const [loading, setLoading] = useState(false);
  const isRetainerReport = RETAINER === data?.reportType;

  const reportsContext = useContext(ReportsContext);

  //   const featureToCheck = RETAINER_REPORT;

  //   const hasFeatureAccess = useCheckFeatureGating(featureToCheck)?.enabled;
  const hasFeatureAccess = true;

  const getReport = () => {
    setLoading(true);
    AccountClient.query({
      query: GET_REPORT,
      variables: {
        reportId: data?.reportId
      },
      fetchPolicy: 'network-only'
    })
      .then((res: any) => {
        const result = res?.data?.getReport;
        setActiveReport(result);
      })
      .catch((err: any) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
        setActiveReportLoading(false);
      });
  };

  useEffect(() => {
    if (data?.reportId && hasFeatureAccess) {
      getReport();
    }
  }, [JSON.stringify(data)]);

  useEffect(() => {
    if (data?.reportId && hasFeatureAccess) {
      setLoading(true);
      setActiveReportLoading(true);
    }
  }, [data?.reportId]);

  if (loading && hasFeatureAccess) {
    return (
      <div className="flex-center full-height">
        <Loading className="w90" />
      </div>
    );
  }

  if (!isRetainerReport) {
    return <></>;
  }

  return (
    <div className="m10 h95 scroll">
      <RetainerReportSheet data={data} />
    </div>
  );
}

export default RetainerReport;
